module.exports = "//docs.gtimg.com/slide/img/slide/application/service/ai/core/pc/task/background-fill/components/palette-ceec98.png";